import { countries, TCountryCode } from 'countries-list';

export const ISOToCountry: (iso: TCountryCode) => string = (iso) => {
  return countries[iso].name;
};
